import React, { useContext } from "react"
import RangeSlider from "./rangeSlider"

// Context API data
import { AppContext } from "../../store/AppContext"

import "./styles.scss"

const Card = ({ sliderItem, updateSliderValue }) => {
  const { toggle } = useContext(AppContext)
  const objectToPass = {}
  sliderItem.inputs.forEach(inp => {
    objectToPass[inp.id] = inp.currentValue
  })
  // Price formatting
  const priceFormat = Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    useGrouping: true,
  })

  // Total price
  const totalPrice = priceFormat.format(
    sliderItem.formula(objectToPass).toFixed(2)
  )
  return (
    <div className="budget__card__main">
      <div className="budget__card__div">
        <div className="card__body">
          {sliderItem.inputs.map((input, i) => {
            return (
              <div key={i}>
                <div className="card__slider__div">
                  {input.type === "range" && (
                    <React.Fragment>
                      <p>{input.title}</p>
                      <RangeSlider
                        value={Number(input.currentValue)}
                        onChange={e => {
                          const currVal = e
                          updateSliderValue(sliderItem.id, input.id, +currVal)
                        }}
                        minVal={input.renderParameters.minVal}
                        minLabelHelperText={
                          input.renderParameters.minLabelHelperText
                        }
                        maxVal={input.renderParameters.maxVal}
                        maxLabelHelperText={
                          input.renderParameters.maxLabelHelperText
                        }
                        size={input.renderParameters.size}
                        helperText={input.renderParameters.helperText}
                        step={input.renderParameters.step || 1}
                        maxLabel={input.renderParameters.maxLabel}
                        minLabel={input.renderParameters.minLabel}
                        skipValue={input.skipValue}
                      />
                    </React.Fragment>
                  )}
                </div>
                {input.type === "radio" && (
                  <>
                    {input.isHidden === false && (
                      <>
                        <p>{input.title}</p>
                        <div className="card__radio__div">
                          {input.renderParameters.options.map((option, i) => (
                            <div key={i} className="radio__div">
                              <div>
                                <input
                                  type="radio"
                                  name={input.title}
                                  onChange={e => {
                                    const newValue = e.target.value
                                    updateSliderValue(
                                      sliderItem.id,
                                      input.id,
                                      newValue
                                    )
                                  }}
                                  defaultChecked={
                                    input.defaultValue === option.value
                                  }
                                  value={option.value}
                                  id={input.title + option.label}
                                />
                              </div>
                              <label
                                className="md:leading-none"
                                htmlFor={input.title + option.label}
                              >
                                {option.label}
                              </label>
                            </div>
                          ))}
                        </div>
                      </>
                    )}
                  </>
                )}
              </div>
            )
          })}
        </div>
        {sliderItem.description && (
          <div className="mt-8 text-lg md:mt-16">{sliderItem.description}</div>
        )}
        <div className="mt-8 card__total__estimate siteFont">
          <div className="btn__container">
            {/* <Link to="/contact" className="get_started_btn">
              get started
            </Link> */}
            <button onClick={() => toggle(true)} className="get_started_btn">
              get started
            </button>
          </div>
          <div className="text__container">
            <h2 className="title">Total Cost Estimate:</h2>
            <p className="price">
              {totalPrice}
              {sliderItem.pricePerMonth && (
                <span className="text-3xl">/mo</span>
              )}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Card
